import CCRadarChart from "../Common/CCRadarChart";
import {prepareBuffer} from "../../util/Buffer";

class ExampleRadarChart extends CCRadarChart {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        const metrics = ['Math', 'Chinese', 'English', 'Geography', 'Physics', 'History'];
        const lisa = [120, 98, 86, 99, 85, 65];
        const bart = [80, 90, 100, 70, 60, 95];

        let series = structuredClone(this.props.Series ?? [{}, {}]);
        series[0].data = lisa;
        series[1].data = bart;

        let radar;
        if (this.state.radar === undefined) {
            radar = { metrics: metrics };
        } else {
            radar = structuredClone(this.state.radar);
            radar.metrics = metrics;
        }

        this.setState({Loading: this.state.fetchBackgroundOperation, Series: series, radar: radar});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let radar = structuredClone(this.state.radar);
        radar.metrics = []
        for (let i = 0; i < buffer.length; i++) {
            radar.metrics.push(buffer[i].get("X_AXIS"));
        }

        let series = structuredClone(this.state.Series);
        if (series.length === 0) {
            series = [{data: []}, {data: []}]
        }
        series[0].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[0].data.push(parseFloat(buffer[i].get("Y_AXIS_2")));
        }
        series[1].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[1].data.push(parseFloat(buffer[i].get("Y_AXIS_1")));
        }

        this.setState({Loading: false, Series: series, radar: radar});
    };
}

export default ExampleRadarChart;
